import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";
import {ref} from "vue";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";
import {DateTime} from 'luxon';


//import ODataStore from "devextreme/data/odata/store";
export const useMdrdStore = defineStore(
    'mdrdStore',
    () => {

        const selectedNomorSambungan = ref(null);
        const latestAccessTime = ref(null);

        const selectedFilterTempoSampaiDengan = ref(null);
        const selectedFilterTanggalSegel = ref(null);
        const selectedFilterTanggalCabut = ref(null);
        const selectedFilterLainLain = ref(null);
        const selectedFilterStatus = ref(null);
        const selectedEditingTindakLanjutRow = ref(null);

        const rekapTagihanBarChartCabangCustomStore = new CustomStore({
            key: "nosbg",
            load: async (loadOptions) => {
                // your custom parameters
                let params = {};
                if (loadOptions.sort) {
                    params.sort = JSON.stringify(loadOptions.sort);
                }
                if (loadOptions.filter) {
                    params.filter = JSON.stringify(loadOptions.filter);
                }
                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }
                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

                const response = await axios.get(`${API_BASE_URL}/chart-jumlah-tunggakan-cabang`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                })

                latestAccessTime.value = null;
                if (response.data) {
                    latestAccessTime.value = response.data.serverTime;
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }

                throw 'Data loading error';
            },
        });

        const rekapTagihanCustomStore = new CustomStore({
            key: "nosbg",
            load: async (loadOptions) => {
                // your custom parameters
                let params = {};

                if (selectedFilterTempoSampaiDengan.value !== null) {
                    let tanggalTempoSampaiDengan = DateTime.fromJSDate(selectedFilterTempoSampaiDengan.value).toFormat('yyyy-MM-dd');
                    params.tanggal_tempo_sampai_dengan = tanggalTempoSampaiDengan;
                }

                if (selectedFilterTanggalSegel.value !== null) {
                    let tanggalSegel = DateTime.fromJSDate(selectedFilterTanggalSegel.value).toFormat('yyyy-MM-dd');
                    params.tanggal_segel=tanggalSegel;
                }

                if (selectedFilterTanggalCabut.value !== null) {
                    let tanggalCabut = DateTime.fromJSDate(selectedFilterTanggalCabut.value).toFormat('yyyy-MM-dd');
                    params.tanggal_cabut=tanggalCabut;
                }

                if (selectedFilterLainLain.value !== null) {
                    //let lainLain = DateTime.fromJSDate(selectedFilterLainLain.value).toFormat('yyyy-MM-dd');
                    params.lain_lain=selectedFilterLainLain.value;
                }

                if (selectedFilterStatus.value !== null) {
                    //let status = DateTime.fromJSDate(selectedFilterStatus.value).toFormat('yyyy-MM-dd');
                    params.status = selectedFilterStatus.value ? true : false;
                }

                if (loadOptions.sort) {
                    params.sort = JSON.stringify(loadOptions.sort);
                }

                if (loadOptions.filter) {
                    params.filter = JSON.stringify(loadOptions.filter);
                }

                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }

                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

                const response = await axios.get(`${API_BASE_URL}/tunggakan-list`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                latestAccessTime.value = null;
                if (response.data) {
                    latestAccessTime.value = response.data.serverTime;

                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }

                throw 'Data loading error';
            },
            update: async (key, values) => {
                // Construct the PUT request URL with the key
                const updateUrl = `${API_BASE_URL}/tindak-lanjut-tagihan/${selectedEditingTindakLanjutRow.value.nosbg}/${selectedEditingTindakLanjutRow.value.oldest_rekening}`;

                try {
                    // Send a PUT request with the updated values
                    const response = await axios.put(updateUrl, values, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });

                    if (response.data) {
                        // Return the updated data or handle it as needed
                        return response.data.data;
                    }
                } catch (error) {
                    // Handle any errors here
                    console.error('Update error:', error);
                    throw error;
                }
            },
        });

        const tugasSegelCustomStore = new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                // your custom parameters
                let params = {};

                console.log('loadOptions tagihan',loadOptions);
    
                if (loadOptions.sort) {
                    params.sort = JSON.stringify(loadOptions.sort);
                }

                if (loadOptions.filter) {
                    params.filter = JSON.stringify(loadOptions.filter);
                }

                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }

                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

                const response = await axios.get(`${API_BASE_URL}/segel-list`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                latestAccessTime.value = null;
                if (response.data) {
                    latestAccessTime.value = response.data.serverTime;

                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }

                throw 'Data loading error';
            },
            /* update: async (key, values) => {
                // Construct the PUT request URL with the key
                const updateUrl = `${API_BASE_URL}/tindak-lanjut-tagihan/${selectedEditingTindakLanjutRow.value.nosbg}/${selectedEditingTindakLanjutRow.value.oldest_rekening}`;

                try {
                    // Send a PUT request with the updated values
                    const response = await axios.put(updateUrl, values, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });

                    if (response.data) {
                        // Return the updated data or handle it as needed
                        return response.data.data;
                    }
                } catch (error) {
                    // Handle any errors here
                    console.error('Update error:', error);
                    throw error;
                }
            }, */
        });

        const petugasSegelCustomStore = new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                // your custom parameters
                let params = {};

                if (loadOptions.sort) {
                    params.sort = JSON.stringify(loadOptions.sort);
                }

                if (loadOptions.filter) {
                    params.filter = JSON.stringify(loadOptions.filter);
                }

                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }

                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

                const response = await axios.get(`${API_BASE_URL}/petugas-segel`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                latestAccessTime.value = null;

                if (response.data) {
                    latestAccessTime.value = response.data.serverTime;

                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }

                throw 'Data loading error';
            },
        
        });
        

        const rekapTagihanScatterCustomStore = new CustomStore({
            key: "nosbg",
            load: async (loadOptions) => {
                // your custom parameters
                let params = {};
                if (loadOptions.sort) {
                    params.sort = JSON.stringify(loadOptions.sort);
                }

                if (loadOptions.filter) {
                    params.filter = JSON.stringify(loadOptions.filter);
                }

                /*if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }
                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }*/

                const response = await axios.get(`${API_BASE_URL}/tunggakan-list`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                })

                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }

                throw 'Data loading error';
            },
        });
        const mdrdCustomStore = new CustomStore({
            key: "id",
            load: async () => {
                const response = await axios.get(`${API_BASE_URL}/cek-tagihan`, {
                    params: {
                        'nosbg': selectedNomorSambungan.value,
                    },
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount
                    };
                }
                throw 'Data loading error';
            },
        });
        const sambunganCustomStore = ref(new CustomStore({
            key: "id",
            load: async (loadOptions) => {

                const response = await axios.get(`${API_BASE_URL}/sambungan`, {
                    params: loadOptions,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount
                    };
                }
                throw 'Data loading error';
            },
        }));

        const infoSambunganCustomStore = new CustomStore({
            key: "id",
            load: async () => {
                const response = await axios.get(`${API_BASE_URL}/info-sambungan`, {
                    params: {
                        'nomorSambungan': selectedNomorSambungan.value,
                    },
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount
                    };
                }
                throw 'Data loading error';
            },
        });

        function setSelectedNomorSambungan(data) {
            selectedNomorSambungan.value = data;
        }


        function setSelectedEditingTindakLanjutRow(data) {
            selectedEditingTindakLanjutRow.value = data;
        }

        function setSelectedFilterTempoSampaiDengan(data) {
            const date = DateTime.fromJSDate(data.value).toFormat('yyyy-MM-dd');
            selectedFilterTempoSampaiDengan.value = date;
        }

        function setSelectedFilterTanggalSegel(data) {
            const date = DateTime.fromJSDate(data.value).toFormat('yyyy-MM-dd');
            selectedFilterTanggalSegel.value = date;
        }

        function setSelectedFilterTanggalCabut(data) {
            const date = DateTime.fromJSDate(data.value).toFormat('yyyy-MM-dd');
            selectedFilterTanggalCabut.value = date;
        }

        function setSelectedFilterLainLain(data) {
            selectedFilterLainLain.value = data.value;
        }

        function setSelectedFilterStatus(data) {
            selectedFilterStatus.value = data.value;
        }


        /*   function isNotEmpty(value) {
               return value !== undefined && value !== null && value !== '';
           }*/

        return {
            selectedFilterTempoSampaiDengan,
            selectedFilterTanggalSegel,
            selectedFilterTanggalCabut,
            selectedFilterLainLain,
            selectedFilterStatus,
            mdrdCustomStore,
            sambunganCustomStore,
            setSelectedNomorSambungan,
            setSelectedFilterTempoSampaiDengan,
            setSelectedFilterTanggalSegel,
            setSelectedFilterTanggalCabut,
            setSelectedFilterLainLain,
            setSelectedFilterStatus,
            infoSambunganCustomStore,
            rekapTagihanCustomStore,
            latestAccessTime,
            rekapTagihanScatterCustomStore,
            rekapTagihanBarChartCabangCustomStore,
            setSelectedEditingTindakLanjutRow,
            tugasSegelCustomStore,
            petugasSegelCustomStore,
        }
    });